<template>
<div class="animated fadeIn">
  <b-card>
    <b-button-toolbar class="pull-right">
      <b-btn variant="primary" @click="showAddAttribute">Add Attribute</b-btn>
    </b-button-toolbar>
  </b-card>

  <b-card>
    <v-client-table :data="attributes" :columns="columns" :options="options" :theme="theme" id="dataTable" ref="dataTable">
      <template slot="actions" slot-scope="data">
        <b-button class="mr-1" size="sm" variant="primary" @click="showEditModal(data.row)"><i class="fa fa-pencil"></i></b-button>
      </template>
      <span slot="is_active" slot-scope="data">{{data.row.is_active ? 'Yes' : 'No'}}</span>
    </v-client-table>
  </b-card>

  <div>
    <b-modal ref="modalAddAttribute" title="Add Attribute" hide-footer @hide="hideAddAttribute" no-enforce-focus>
      <attribute-form-add v-if="canShowAddAttribute" @success="addAttributeSuccess" @cancel="cancelAddAttribute" />
    </b-modal>
    <b-modal ref="modalEditAttribute" title="Edit Attribute" hide-footer @hide="hideEditAttribute" no-enforce-focus>
      <attribute-form-edit v-if="selectedAttribute" :attribute="selectedAttribute" @success="editAttributeSuccess" @cancel="cancelEditAttribute" />
    </b-modal>
  </div>
</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import AttributeFormAdd from './AttributeFormAdd'
import AttributeFormEdit from './AttributeFormEdit'

export default {
  name: 'RoomAtrributeList',
  components: {
    AttributeFormAdd,
    AttributeFormEdit,
  },
  computed: mapState({
    attributes: state => state.attributes.all,
  }),
  data: function() {
    return {
      columns: [
        'id',
        'name',
        'type',
        'default_value',
        'is_active',
        'actions'
      ],
      options: {
        headings: {
          id: 'ID',
          name: 'Name',
          type: 'Type',
          default_value: 'Default Value',
          is_active: 'Active',
          actions: 'Actions'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      canShowAddAttribute: false,
      selectedAttribute: null,
    }
  },
  methods: {
    showAddAttribute() {
      this.canShowAddAttribute = true
      this.$refs.modalAddAttribute.show()
    },
    cancelAddAttribute() {
      this.$refs.modalAddAttribute.hide()
    },
    addAttributeSuccess() {
      this.$refs.modalAddAttribute.hide()
      this.$store.dispatch('attributes/getAttributes')
    },
    hideAddAttribute() {
      this.canShowAddAttribute = false
    },
    showEditModal(attribute) {
      this.selectedAttribute = attribute
      this.$refs.modalEditAttribute.show()
    },
    editAttributeSuccess() {
      this.$refs.modalEditAttribute.hide()
      this.$store.dispatch('attributes/getAttributes')
    },
    cancelEditAttribute() {
      this.$refs.modalEditAttribute.hide()
    },
    hideEditAttribute() {
      this.selectedAttribute= null
    },
    showFloorModal(attribute) {
      this.selectedAttribute = attribute
      this.$refs.modalFloors.show()
    }
  },
  created () {
    this.$store.dispatch('attributes/getAttributes')
  }
}
</script>
